import { InvokeParams, request } from '@huolala-tech/request';
import { RequestFailed } from './RequestFailed';

export interface Options extends Omit<InvokeParams, 'method' | 'url' | 'data'> {
  data?: unknown;
  params?: Record<string, any>;
  prefix?: string;
}

const removeUndefinedValues = (params: unknown) => {
  if (!params) return {};
  if (params instanceof URLSearchParams) {
    return params;
  }
  return JSON.parse(JSON.stringify(params));
};

class ApiRequest {
  defaultPrefix: string;

  constructor(public subDomain: string) {
    this.defaultPrefix = `https://${subDomain}.blucas.me`;
  }

  get<T>(path: string, options?: Options) {
    return this.request<T>('GET', path, options);
  }

  post<T>(path: string, options?: Options) {
    return this.request<T>('POST', path, options);
  }

  put<T>(path: string, options?: Options) {
    return this.request<T>('put', path, options);
  }

  delete<T>(path: string, options?: Options) {
    return this.request<T>('DELETE', path, options);
  }

  private async request<T>(
    method: string,
    path: string,
    options: Options = {},
  ) {
    const { prefix = this.defaultPrefix, data, params } = options;
    const qs = new URLSearchParams(removeUndefinedValues(params))
      .toString()
      .replace(/^./, '?$&');
    const url = prefix + path + qs;

    const res = await request<T>({
      url,
      method,
      data: data as any,
      ...options,
    });
    if (res.statusCode >= 200 && res.statusCode < 300) {
      return res.data;
    }
    throw new RequestFailed(res);
  }
}

export const pageSpy = new ApiRequest('pagespy');
export const harmony = new ApiRequest('harmony');
